// extracted by mini-css-extract-plugin
export default {"subtitle":"OrderCard_subtitle__5313w","subtitleBold":"OrderCard_subtitleBold__KGS0V"};